<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Requisição:</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-9 col-sm-1">
              <v-select label="Operadora" v-model="current.operadora" :items="operadoras" outlined dense disabled></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select label="Tipo" v-model="current.tipo" :items="tipos" outlined dense></v-select>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field label="Cliente" v-model="current.cliente" outlined dense></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field label="Endereço" v-model="current.endereco" outlined dense></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="Bairro" v-model="current.bairro" outlined dense></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="Cidade" v-model="current.cidade" outlined dense></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="CEP" v-model="current.cep" outlined dense></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field label="Mapa" v-model="current.maps" outlined dense></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field label="Comentário" v-model="current.comentario" outlined dense></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()" class="ma-2">Enviar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: {
        tipo: 1 //nova instalacao
    },
    tipos: [
      { text: "Nova Instalação", value: 1 },
      { text: "Mudança de Endereço", value: 2 }
    ],
    operadoras: [
      { text: "Vivavox", value: 1 },
      { text: "Link1000 - Cachoeira de Minas", value: 2 },
      { text: "Link1000 - Conceição dos Ouros", value: 3 },
      { text: "G2", value: 4 }
    ]
  }),
  created: function(){
    var operadora = this.$route.params.operadora;
    if(operadora){
        if(operadora=="vivavox"){
            this.current.operadora = 1;
        }else if(operadora=="link1000cdm"){
            this.current.operadora = 2;
        }else if(operadora=="link1000cdo"){
            this.current.operadora = 3;
        }else if(operadora=="g2"){
            this.current.operadora = 4;
        }else{
            alert("Operadora desconhecida!");
        }
    }

  },
  methods: {
    save: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
      .post("/viabilidade/form", this.current, {
          headers: { Authorization: "Bearer " + token }
      })
      .then(function() {
          alert("Viabilidade criada com sucesso!");
          me.current = {
            tipo:1,
            operadora: me.current.operadora
          };
      })
      .catch(function(error) {
          console.log(error);
          alert("Falha ao criar viabilidade!");
      });
    }
  },
  filters: {
    formatStatus: function(item){
      var text = "";
      if (item.status==1){
        text = "Aguardando";
      }else if(item.status==2){
        text = "Positiva";
      }else if(item.status==3){
        text = "Negativa";
      }else if(item.status==4){
        text = "Vistoria";
      }else if(item.status==5){
        text = "Rejeitada";
      }
      return text;
    }
  }
};
</script>